export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_fragment_2.569b59ae.jpg";